// extracted by mini-css-extract-plugin
export default {"coresec":"corememberssec_coresec__ltnIF","corecontainer":"corememberssec_corecontainer__4pbla"};